<template>
  <div>
    <div class="gray-bg">
      <main-header @listenerChild="listenerChild"/>
    </div>
    <div v-if="isLoaded">
      <div v-if="moreProducts.length === 0">
        <v-alert
            text
            type="error"
        >
          محصولی یافت نشد
        </v-alert>
      </div>
      <more-products :products-array="moreProducts" :page-title="'جستجو '+ searchKeyWord"/>
    </div>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MainHeader from "./mainHeader";
import MoreProducts from "./moreProducts";

let _this = null;

export default {
  name: "search",
  components: {
    MainHeader,
    MoreProducts
  },
  data: () => ({
    isLoaded: false,
    moreProducts: [],
    searchKeyWord: null,
    showLoaderDialog: false,

  }),
  metaInfo() {
    return {
      title: window.projectName + " جستجو" + this.searchKeyWord,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + " جستجو" + this.searchKeyWord,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + " جستجو" + this.searchKeyWord,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  mounted() {
    _this = this;
    this.searchKeyWord = this.$route.query.KeyWord
    this.getData();
    console.log("Mounted");
  },
  methods: {
    listenerChild(reply) {
      this.searchKeyWord = reply;
      this.getData()
    },
    getData() {

      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("KeyWord", this.searchKeyWord);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/SearchEngine/ShowProductByKeyWord", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            _this.moreProducts = json
            this.showLoaderDialog = false
            _this.isLoaded = true
          })
          .catch(error => console.log('error', error));
    },

  }
}
</script>

<style scoped>

</style>
